// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import 'babel-polyfill'
// import 'es6-promise/auto'
import router from '@/router'
import store from '@/store'  
import VueCookie from 'vue-cookie' 
import '@/assets/css/index.css';
import header from '@/components/header.vue';
import footer from '@/components/footer.vue';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import httpRequest from '@/utils/httpRequest';
import '@/plugin/vant'// 引入vant组件
import VueBarcode from '@xkeshi/vue-barcode' // 导入条形码插件
import httpRequest from './api/api.js'   //axios实例化后引入取名http
import httpRequests from './api/baseUrl.js'
 
// Vue.prototype.http = httpRequest   //放入全局
Vue.component('barcode', VueBarcode) // 声明条形码组件
Vue.use(VueCookie)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.component('crumbs',header);
Vue.component('Footer',footer);
// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$https = httpRequests // ajax请求方法
// Vue.prototype.isAuth = isAuth     // 权限方法

// 保存整站vuex本地储存初始状态
// window.SITE_CONFIG['storeState'] = cloneDeep(store.state)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, 
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js